module.exports = __webpack_public_path__ + "img/timeline_miscevent-4.98822dc7.jpg";